import { FC } from 'react';
import Layout from 'layouts/Layout';
import PageTitle from 'components/PageTitle';
import Users from '../components/users';

const Index: FC = () => {
  return (
    <Layout>
      <PageTitle title="ユーザーエントリー"/>      
      <Users/>
    </Layout>
  )
}

export default Index;
